import { useMemo } from 'react';
import Fuse from 'fuse.js';

/**
 * Searches rows in the browser with Fuse. Returns the matches in relevance order, or every
 * row when there's no search. The index is rebuilt only when rows or searchOptions change,
 * so pass a stable searchOptions (see searchOptions.js).
 */
export const useAdminSearch = (rows, searchOptions, search) => {
	const fuse = useMemo(() => new Fuse(rows, searchOptions), [rows, searchOptions]);

	return useMemo(
		() => (search ? fuse.search(search).map((result) => result.item) : rows),
		[fuse, rows, search],
	);
};
